class LocatorForm extends HTMLElement {
    constructor() {
        super();
        this.domain = "https://heirloomroses.demo.brainvire.dev";
        this.storageKey = "locator";

        // Use querySelectorAll for selecting elements within the custom element
        this.zoneSelector = document.querySelectorAll(".location_and_grow_zone");
        this.zipcodeInput = this.querySelectorAll(".hardiness-zip-code");
        this.currentLocation = this.querySelectorAll(".zipcode-btns-wrapper .btn-cl");
        this.errorMessage = this.querySelectorAll(".zipcode-input-wrapper .error-message");
        this.hardinessZonemsg = this.querySelectorAll(".success-message-hardiness-zone");
        this.zipCodeMsg = this.querySelectorAll(".success-message-zip-code");

        this.form = this.querySelector("form");

        if (this.form) {
            this.form.addEventListener("submit", this.handleFormSubmit.bind(this));
        }

        if (this.currentLocation.length) {
            this.currentLocation.forEach(btn => btn.addEventListener("click", this.fetchCurrentLocation.bind(this)));
        } else {
            console.error("Current location button not found.");
        }
    }

    connectedCallback() {
        this.session = this.getLocationSession();
        this.setSessionValue();
    }



    getLocationSession() {
        let session = localStorage.getItem(this.storageKey);
        if (session) {
            return JSON.parse(session);
        }
        return session;
    }

    setSessionValue() {
        if (!this.session) return;
        this.zoneSelector.forEach(zone => {
            zone.querySelector(".location-zone span.location").innerText = this.session.zone;
            zone.querySelector(".location-zip-code span.location-zip").innerText = this.session.zip;
        });
        this.hardinessZonemsg.forEach(msg => {
            msg.innerText = "Hardiness zone: " + this.session.zone;
            msg.classList.remove("hide")
        });
        this.zipCodeMsg.forEach(msg => {
            msg.innerText = "Zip Code: " + this.session.zip;
            msg.classList.remove("hide")
        });
        this.errorMessage.forEach(msg => msg.classList.add('hide'));
    }

    async fetchCurrentLocation(evt) {
        console.log("location fetching");

        for (const locationBtn of this.currentLocation) {
            locationBtn.classList.add("btn--loading");
        }

        if (!navigator.geolocation) {
            console.error('Geolocation is not supported by this browser.');
            return;
        }

        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0
                });
            });
            console.log(position);
            const { latitude, longitude } = position.coords;

            const geocodeResponse = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`);
            const geocodeData = await geocodeResponse.json();

            const zipCode = geocodeData.address.postcode;

            if (!zipCode) {
                throw new Error('Could not retrieve ZIP code');
            }

            this.zipcodeInput.forEach(input => input.value = zipCode);

            this.form.dispatchEvent(new Event('submit'));

        } catch (error) {
            console.error('Error fetching location:', error);

            // Remove loading class on error
            for (const locationBtn of this.currentLocation) {
                locationBtn.classList.remove("btn--loading");
            }
            const checkmarkIcon = this.querySelector(".checkmark-icon");
            checkmarkIcon.classList.add("hide");

            if (error.code === 1) {
                alert('Please allow location access to use this feature.');
            } else if (error.code === 2) {
                alert('Unable to retrieve your location. Please try again or enter ZIP code manually.');
            } else if (error.code === 3) {
                alert('Location request timed out. Please try again.');
            } else {
                alert('An error occurred while trying to get your location. Please enter your ZIP code manually.');
            }
        }
    }

    async handleFormSubmit(evt) {
        evt.preventDefault();

        // Get all location buttons specifically from zipcode-btns-wrapper
        const locationButtons = document.querySelectorAll(".zipcode-btns-wrapper .submit-btn");

        // Check if any locationButton has btn--loading class
        const hasLoadingClass = Array.from(locationButtons).some(btn =>
            btn.classList.contains("btn--loading")
        );

        // If no loading class exists, add it to all buttons
        if (!hasLoadingClass) {
            locationButtons.forEach(btn => {
                btn.classList.add("btn--loading");
            });
        }

        let zipCode = this.form.querySelector("input[name='zip']").value;
        if (zipCode.trim().length == 0) return;

        const fetchReq = await fetch(`${this.domain}/api/zone?zip_code=${zipCode}`);
        const fetchRes = await fetchReq.json();


        const removeLoader = document.querySelectorAll(".zipcode-btns-wrapper .btn");

        if (removeLoader) {
            // Remove loading class from all location buttons after API call completes
            removeLoader.forEach(btn => {
                btn.classList.remove("btn--loading");
            });
        } 
        if (!fetchRes.data.zoneData[0]) {
            this.errorMessage.forEach(msg => msg.classList.remove('hide'));
            this.hardinessZonemsg.forEach(msg => msg.classList.add('hide'));
            this.zipCodeMsg.forEach(msg => msg.classList.add('hide'));          
            const checkmarkIcon = this.querySelector(".checkmark-icon");
            checkmarkIcon.classList.add("hide");
            return;
        }

        const zoneDetail = {
            zone: fetchRes.data.zoneData[0].hardiness_zone.hardiness_zone_name.split(' ')[1],
            zip: zipCode,
            dates: this.getDates(fetchRes.data.zoneData[0].hardiness_zone)
        };

        localStorage.setItem(this.storageKey, JSON.stringify(zoneDetail));
        this.session = zoneDetail;
        this.setSessionValue();
        this.errorMessage.forEach(msg => msg.classList.add('hide'));
        const checkmarkIcon = this.querySelector(".checkmark-icon");
        checkmarkIcon.classList.remove("hide");
        if (window.productHardinessZones.includes(zoneDetail.zone)) {
            const zoneAvailability = document.querySelector(".custom-product-availability");

            if (zoneAvailability) {
                const startArriveTime = document.querySelector(".arrives .start_time");
                const endArriveTime = document.querySelector(".arrives .end_time");

                if (startArriveTime) {
                    startArriveTime.textContent = zoneDetail.dates.start;
                }
                if (endArriveTime && zoneDetail.dates.end != "Anytime" ) {
                    endArriveTime.textContent = "and " + zoneDetail.dates.end;
                }

                document.querySelector(".loading-skeleton")?.classList.add("hide");
                zoneAvailability.classList.remove("hide");
                document.querySelector(".hardiness_zone_product_explore")?.classList.add("hide");
                document.querySelector(".no_hardiness_zone_product")?.classList.add("hide");
            }
        } else {
            if (["1", "2", "12"].includes(zoneDetail.zone)) {
                document.querySelector(".no_hardiness_zone_product")?.classList.remove("hide");
                document.querySelector(".hardiness_zone_product_explore")?.classList.add("hide");
            } else {
                const hardinessElement = document.querySelector(".hardiness_modal_link");
                if (hardinessElement) {
                    hardinessElement.setAttribute("hardiness_id", zoneDetail.zone);
                    hardinessElement.textContent = "Hardiness Zone " + zoneDetail.zone;
                }
                document.querySelector(".hardiness_zone_product_explore")?.classList.remove("hide");
                document.querySelector(".no_hardiness_zone_product")?.classList.add("hide");
            }

            document.querySelector(".loading-skeleton")?.classList.add("hide");
            document.querySelector(".custom-product-availability")?.classList.add("hide");
        }
    }

    getDates(data) {
        const convertToDate = (dateStr) => {
            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            let [month, day, year] = dateStr.split("/").map(Number);
            let date = new Date(year, month - 1, day);
            date.setFullYear(date.getFullYear() + 1);

            const getDaySuffix = (day) => {
                if (day >= 11 && day <= 13) return "th";
                switch (day % 10) {
                    case 1: return "st";
                    case 2: return "nd";
                    case 3: return "rd";
                    default: return "th";
                }
            };

            return `${date.getDate()}${getDaySuffix(date.getDate())} ${months[date.getMonth()]} ${date.getFullYear()}`;
        }

        return {
            start: data.shipping_start_date == "Anytime" ? "Anytime" : convertToDate(data.shipping_start_date),
            end: data.shipping_end_date == "Anytime" ? "Anytime" : convertToDate(data.shipping_end_date)
        };
    }
}

customElements.define('locator-form', LocatorForm);